import Dependencies from '../utilities/dependencies';

export default class MosaicSlider {

	/**
	 * CSS selectors that must exist for this module to run
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getHolderSelectors = () => ['.mosaic-slider', '.mosaic-item-gallery'];

	/**
	 * Dependencies that this module requires
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getDependencies = () => [Dependencies.libraries.splide];

	/**
	 * Runtime injected CSS classes
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getClassList = () => Object.create({});

	/** @type {HTMLElement} */
	#holderElement;

	/**
	 * @param {HTMLElement} holderElement
	 */
	constructor(holderElement) {
		this.#holderElement = holderElement;

        const splide = new Splide(this.#holderElement.querySelector('.splide'), {
			rewind: true,
			width: '100%',
			pagination: false
        });

		const progressBar = splide.root.querySelector('.slider-progress-bar');

		splide.on( 'mounted move', function () {
			var end  = splide.Components.Controller.getEnd() + 1;
			var rate = Math.min( ( splide.index + 1 ) / end, 1 );
			progressBar.style.width = String( 100 * rate ) + '%';
		} );

        splide.mount();

	}

}
